module.exports = require("/Users/daviddavidson/Desktop/dev/blog/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 862
// module chunks = 231608221292675